import Additional from "@core/Additional.js";
import ActionTool from "@core/ActionTool.js";
import Constant from "@constant/index.js";
import Sku from "@core/Sku.js";
import {$event_publisher} from "@util/util.js";

export default class OptionAdditional extends Additional{
    constructor(){
        super();
        this._additionalType = Constant.ADDITIONAL_TYPE.OPTION;
        this._modify_count_status = true;
         // 选件组件
         this._optionList = null;
    }

    getMaxBuyCount(item){
        let res = [item._stock, item._maxPurchase, this._parent._count, this._parent._maxPurchase];
        res.sort(function(a,b){
            return a-b;
        });
        return res[0];
    }

    init(data){
        this._data = data;

        this._data.forEach(x => {
            let _sku = new Sku();
            _sku.init(x, this);
            this.addItem(_sku);
        });
    }

    //更改数量
    modifyCount(count, oid){
        if(this._modify_count_status == false){
            return Promise.reject(Constant.MSG.MODIFYING);
        }
        this._modify_count_status = false;
        return new Promise((reslove,reject)=>{
            ActionTool.modifyCount({model:this._parent, count:count, optionId:oid}).then(data=>{
                //价格变动
                $event_publisher.broadcast(Constant.EVENT_KEY.PRICE, data);
                //重新设置MainSku的属性 + 重新渲染附属商品
                $event_publisher.broadcast(Constant.EVENT_KEY.MODIFY_MAINSKU_COUNT, {model:this._parent, data:data});
                reslove();
                this._modify_count_status = true;
            }).catch(err=>{
                reject(err);
                this._modify_count_status = true;
            })
        })
    }

    getStockMsg(){
        return "";
    }
}